import { render } from "./ReferralForm.vue?vue&type=template&id=5850d050"
import script from "./ReferralForm.vue?vue&type=script&lang=js"
export * from "./ReferralForm.vue?vue&type=script&lang=js"

import "./ReferralForm.vue?vue&type=style&index=0&id=5850d050&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__